import moment from 'moment';
import getDecodedToken from '../auth/utils/getDecodedToken';
import config from '../../config';

const getHistoricFieldData = (userData, fieldName, dataFieldName) => {
  if (userData.get(fieldName).size > 0) {
    return userData.getIn([fieldName, userData.get(fieldName).size - 1, dataFieldName]);
  } else {
    return null;
  }
};

const sendInfoToIntercom = (user, courses, command) => {
  const intercomSettings = {
    app_id: config.intercom.appId,
  };

  if (user.get('loaded')) {
    const activeSubscription = user
      .getIn(['data', 'subscriptions'])
      .find(sub => sub.get('status') === 'active' || sub.get('status') === 'trialing');
    const userData = user.get('data');

    // Core Intercom ATTRS.
    intercomSettings.user_id = userData.get('id');
    intercomSettings.created_at = userData.get('created_at');
    intercomSettings.name = userData.get('name');
    intercomSettings.email = getDecodedToken().email;
    intercomSettings.user_hash = userData.get('intercom_user_hash');

    // Custom Intercom ATTRS.
    intercomSettings.trial_user = !!activeSubscription && activeSubscription.get('status') === 'trialing';
    intercomSettings.subscriber = !!activeSubscription && activeSubscription.get('status') === 'active';
    intercomSettings.movement_specialist = userData.get('roles').indexOf('ms') !== -1;
    if (userData.get('birthday')) {
      intercomSettings.dob = moment.utc(userData.get('birthday')).format('MM/DD/YYYY');
    } else {
      intercomSettings.dob = null;
    }
    intercomSettings.gender = userData.get('gender');
    intercomSettings.home_course = userData.get('course');

    // Only sends the latest item from the list.
    intercomSettings.handicap = getHistoricFieldData(userData, 'handicaps', 'handicap');
    intercomSettings.best_score = getHistoricFieldData(userData, 'scores', 'score');
    intercomSettings.driving_distance = getHistoricFieldData(userData, 'drivingDistances', 'distance');
    intercomSettings.seven_iron = getHistoricFieldData(userData, 'sevenIronDistances', 'distance');

    if (courses.get('loaded')) {
      courses.get('data').forEach(course => {
        const courseId = course.get('id');
        intercomSettings[`enrolledcourse_${courseId}`] = course.get('enrolled');
        intercomSettings[`finishedcourse_${courseId}`] = course.get('complete');
      });
    }
  }

  window.Intercom(command, intercomSettings);
};

export default sendInfoToIntercom;



// WEBPACK FOOTER //
// ./src/common/utils/sendInfoToIntercom.js